import invariant from 'react-utils/invariant';
export function validateApiClientShape(apiClient) {
  invariant(apiClient.get, 'expected apiClient to have function "get"');
  invariant(apiClient.post, 'expected apiClient to have function "post"');
  invariant(apiClient.put, 'expected apiClient to have function "put"');
  invariant(apiClient.delete, 'expected apiClient to have function "delete"');
}